import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";

import { AnnouncementUrlQueryParams } from "./urls";
import AnnouncementCreate from "./views/AnnouncementCreate";
import AnnouncementDetails from "./views/AnnouncementDetails";
import AnnouncementListComponent from "./views/AnnouncementList";

const AnnouncementList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));
  return <AnnouncementListComponent params={params} />;
};

const AnnouncementDetailsView: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const { ...qs } = parseQs(location.search.substr(1));
  const params: AnnouncementUrlQueryParams = {
    ...qs
  };

  return <AnnouncementDetails id={decodeURIComponent(id)} params={params} />;
};

const Announcements = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.announcements)} />
      <Routes>
        <Route path={""} element={<AnnouncementList />} />
        <Route path={"add"} element={<AnnouncementCreate />} />
        <Route path={":id"} element={<AnnouncementDetailsView />} />
      </Routes>
    </>
  );
};

export default Announcements;
